module.exports = __webpack_public_path__ + "media/backgrounds/laptop-bg-c336f1a7.png";